/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcNoticeRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M19.333 2.664A1.9 1.9 0 0 1 21.9 4.443v14.055a1.9 1.9 0 0 1-2.567 1.779L11.4 17.302V18.5a3.4 3.4 0 1 1-6.8 0v-2.424H4a1.9 1.9 0 0 1-1.9-1.9V8.764a1.9 1.9 0 0 1 1.9-1.9h4.13zm.767 1.779a.1.1 0 0 0-.135-.094L9.194 8.39v6.164l10.77 4.038a.1.1 0 0 0 .136-.093zM6.4 16.076V18.5a1.6 1.6 0 1 0 3.2 0v-1.873l-1.47-.55zM4 8.664a.1.1 0 0 0-.1.1v5.412a.1.1 0 0 0 .1.1h3.394V8.664z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcNoticeRegular;
